import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import Logout from '../../components/Logout';
import HeaderBar from '../../components/HeaderBar';
import MenuDrawer from '../../components/MenuDrawer';
import { UserActions } from '../../actions';

class App extends Component {
  constructor(props) {
    super(props);

    this.logout = this.logout.bind(this);
    this.openDrawer = this.openDrawer.bind(this);

    this.state = {
      open: false
    };
  }

  componentWillMount() {
    const { user, dispatch } = this.props;
    if (!user || !user.profile) {
      dispatch(UserActions.getProfile());
    }
  }

  openDrawer() {
    this.setState({open:true});
  }

  logout() {
    const { auth, dispatch } = this.props;
    auth.logout(dispatch);
    browserHistory.push('/login');
  }

  render() {
    const { user } = this.props;
    let children = null;
    if (this.props.children) {
      children = React.cloneElement(this.props.children, {
        auth: this.props.route.auth
      })
    }

    const profile = (user && user.profile) ? user.profile : null;

    const title = (profile && profile.name) ? `Welcome, ${profile.name}!` : 'Welcome!';

    const logout = <Logout onClick={this.logout} />

    const content = (
      <div>
        <HeaderBar title={title} onLeftIconClick={this.openDrawer} rightElement={logout} />
        <MenuDrawer open={this.state.open} onRequestChange={(open) => { this.setState({open})}} />
        <div className="container">
          <div className="row">
            <div className="col s12">
              {children}
            </div>
          </div>
        </div>
      </div>);
    return content;
  }
}

const mapStateToProps = (state) => {
  const { user } = state;
  return {
    user
  }
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/index.js